import type { ExplicitAddress } from '@cronos-app/sdk';
import { useTokenConfig } from '@ui/hooks/contracts/useTokenConfig';
import { create } from 'zustand';

import { useH2SwapForm } from './components/H2SwapForm/useH2SwapForm';

interface H2SwapDialogStore {
  isOpen: boolean;
  agentTokenAddress: ExplicitAddress;
  bondingTokenAddress: ExplicitAddress;
  closable: boolean;
  open: (options: {
    agentTokenAddress: ExplicitAddress;
    bondingTokenAddress: ExplicitAddress;
  }) => void;
  close: () => void;
}

export const useH2SwapDialog = create<H2SwapDialogStore>((set) => ({
  isOpen: false,
  agentTokenAddress: '',
  bondingTokenAddress: '',
  closable: true,
  close: () => set({ isOpen: false }),
  open: ({ agentTokenAddress, bondingTokenAddress }) => {
    // reset store
    useH2SwapDialog.setState(useH2SwapDialog.getInitialState(), true);
    useH2SwapForm.setState(useH2SwapForm.getInitialState(), true);
    set({
      isOpen: true,
      agentTokenAddress,
      bondingTokenAddress,
    });
  },
}));

export const useH2SwapFromTokenInfo = () => {
  const agentTokenAddress = useH2SwapDialog((s) => s.agentTokenAddress);
  const fromToken = useH2SwapForm((s) => s.fromToken);
  const fromTokenInfo = useTokenConfig({
    token: fromToken,
    tokenAddress: agentTokenAddress,
  });
  return fromTokenInfo;
};

export const useH2SwapToTokenInfo = () => {
  const agentTokenAddress = useH2SwapDialog((s) => s.agentTokenAddress);
  const toToken = useH2SwapForm((s) => s.toToken);
  const toTokenInfo = useTokenConfig({
    token: toToken,
    tokenAddress: agentTokenAddress,
  });
  return toTokenInfo;
};
